// 登山エリアデータ（不変性担保）
export const MOUNTAIN_AREAS = Object.freeze({
  NORTHERN_ALPS: {
    id: 'northern_alps',
    name: '北アルプス',
    prefectures: ['長野県', '富山県', '岐阜県'],
    mountains: ['立山', '剣岳', '槍ヶ岳', '穂高岳', '燕岳', '涸沢岳', '白馬岳', '五竜岳', '鹿島槍ヶ岳', '薬師岳'],
    elevationRange: { min: 1500, max: 3000 },
    description: '日本の屋根とも呼ばれる雄大な山脈'
  },
  CENTRAL_ALPS: {
    id: 'central_alps',
    name: '中央アルプス',
    prefectures: ['長野県', '岐阜県'],
    mountains: ['木曽駒ヶ岳', '宝剣岳', '空木岳', '越百山', '南駒ヶ岳'],
    elevationRange: { min: 1800, max: 2956 },
    description: '木曽山脈を中心とした稜線歩きが魅力の山域'
  },
  SOUTHERN_ALPS: {
    id: 'southern_alps',
    name: '南アルプス',
    prefectures: ['長野県', '山梨県', '静岡県'],
    mountains: ['北岳', '間ノ岳', '農鳥岳', '塩見岳', '赤石岳', '聖岳', '光岳', '悪沢岳'],
    elevationRange: { min: 2000, max: 3193 },
    description: '日本三大山脈の一つで深い谷と鋭い峰が特徴'
  },
  YATSUGATAKE: {
    id: 'yatsugatake',
    name: '八ヶ岳',
    prefectures: ['長野県', '山梨県'],
    mountains: ['八ヶ岳', '赤岳', '編笠山', '阿弥陀岳', '硫黄岳', '天狗岳'],
    elevationRange: { min: 1600, max: 2899 },
    description: '火山活動で形成された美しい山並み'
  },
  OKUCHICHIBU: {
    id: 'okuchichibu',
    name: '奥秩父',
    prefectures: ['埼玉県', '東京都', '山梨県', '長野県'],
    mountains: ['金峰山', '瑞牆山', '甲武信ヶ岳', '雲取山', '大菩薩嶺'],
    elevationRange: { min: 1000, max: 2599 },
    description: '首都圏からもアクセスしやすい奥深い山域'
  },
  TANIGAWA_JOSHINETSU: {
    id: 'tanigawa_joshinetsu',
    name: '谷川・上信越',
    prefectures: ['群馬県', '新潟県', '長野県'],
    mountains: ['谷川岳', '苗場山', '巻機山', '平ヶ岳', '火打山', '妙高山'],
    elevationRange: { min: 1200, max: 2462 },
    description: '豪雪地帯ならではの稜線と展望が楽しめる山域'
  },
  NIKKO_NASU: {
    id: 'nikko_nasu',
    name: '日光・那須',
    prefectures: ['栃木県', '群馬県', '福島県'],
    mountains: ['男体山', '日光白根山', '皇海山', '那須岳', '茶臼岳'],
    elevationRange: { min: 1000, max: 2578 },
    description: '火山と湖沼、温泉地を含む北関東の代表的な山域'
  },
  TANZAWA: {
    id: 'tanzawa',
    name: '丹沢',
    prefectures: ['神奈川県'],
    mountains: ['塔ノ岳', '蛭ヶ岳', '大山', '柚子ノ頭', '丸山', '檜洞山'],
    elevationRange: { min: 600, max: 1673 },
    description: '首都圏の奥座敷として人気の登山エリア'
  },
  HAKONE: {
    id: 'hakone',
    name: '箱根・伊豆',
    prefectures: ['神奈川県', '静岡県'],
    mountains: ['金時山', '明神ヶ岳', '大観山', '冠ヶ岳', '天城山'],
    elevationRange: { min: 800, max: 1438 },
    description: '海と温泉地に近い展望のよい山域'
  },
  TAKAO: {
    id: 'takao',
    name: '奥多摩・高尾',
    prefectures: ['東京都', '神奈川県', '山梨県'],
    mountains: ['高尾山', '陣馬山', '御岳山', '大岳山', '雲取山'],
    elevationRange: { min: 500, max: 2017 },
    description: '都心からアクセスしやすい低山から中級山岳の山域'
  },
  ODAIGAHARA: {
    id: 'odaigahara',
    name: '大峰・大台ヶ原',
    prefectures: ['奈良県', '三重県', '和歌山県'],
    mountains: ['大台ヶ原山', '山上ヶ岳', '八経ヶ岳', '釈迦ヶ岳'],
    elevationRange: { min: 1000, max: 1915 },
    description: '紀伊山地の深い森と稜線を歩ける山域'
  },
  DAISETSUZAN: {
    id: 'daisetsuzan',
    name: '大雪山系',
    prefectures: ['北海道'],
    mountains: ['旭岳', '大雪山', '黒岳', '北鎮岳'],
    elevationRange: { min: 1500, max: 2290 },
    description: '北海道の屋根と呼ばれる広大な山域'
  },
  TATEYAMA: {
    id: 'tateyama',
    name: '立山・剱',
    prefectures: ['富山県'],
    mountains: ['立山', '剣岳', '大日岳', '五色ヶ原'],
    elevationRange: { min: 1500, max: 3015 },
    description: 'アルプスの北端を飾る名峰'
  },
  MOUNTAIN_FUJI: {
    id: 'mountain_fuji',
    name: '富士・御坂',
    prefectures: ['静岡県', '山梨県'],
    mountains: ['富士山', '三ツ峠山', '黒岳', '節刀ヶ岳', '毛無山'],
    elevationRange: { min: 1000, max: 3776 },
    description: '富士山と周辺の展望がよい山域'
  }
});

// 標高区分（不変性担保）
export const ELEVATION_CATEGORIES = Object.freeze({
  LOW: {
    id: 'low',
    name: '低山',
    range: { min: 0, max: 999 },
    description: '1000m未満の山々',
    color: 'green',
    examples: ['高尾山', '金時山', '大室山']
  },
  MEDIUM: {
    id: 'medium',
    name: '中級山岳',
    range: { min: 1000, max: 1999 },
    description: '1000m〜2000mの山々',
    color: 'orange',
    examples: ['塔ノ岳', '大山', '大台ヶ原']
  },
  HIGH: {
    id: 'high',
    name: '高山',
    range: { min: 2000, max: 2999 },
    description: '2000m〜3000mの山々',
    color: 'red',
    examples: ['北岳', '立山', '槍ヶ岳']
  },
  ULTRA_HIGH: {
    id: 'ultra_high',
    name: '超高山',
    range: { min: 3000, max: 4000 },
    description: '3000m以上の山々',
    color: 'purple',
    examples: ['富士山', '槍ヶ岳', '北岳']
  }
});

// エリアの平坦なリスト
export const MOUNTAIN_AREAS_LIST = Object.freeze(
  Object.values(MOUNTAIN_AREAS).map(area => ({
    id: area.id,
    name: area.name,
    prefectures: area.prefectures,
    elevationRange: area.elevationRange
  }))
);

// 標高区分の平坦なリスト
export const ELEVATION_CATEGORIES_LIST = Object.freeze(Object.values(ELEVATION_CATEGORIES));

// 地域別都道府県データ（不変性担保）
export const REGIONS = Object.freeze({
  HOKKAIDO: ['北海道'],
  TOHOKU: ['青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県'],
  KANTO: ['東京都', '神奈川県', '埼玉県', '千葉県', '茨城県', '栃木県', '群馬県'],
  CHUBU: ['山梨県', '長野県', '新潟県', '富山県', '石川県', '福井県', '静岡県', '愛知県', '岐阜県'],
  KINKI: ['三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県'],
  CHUGOKU: ['鳥取県', '島根県', '岡山県', '広島県', '山口県'],
  SHIKOKU: ['徳島県', '香川県', '愛媛県', '高知県'],
  KYUSHU: ['福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県']
});

// 地域名のマッピング
export const REGION_NAMES = Object.freeze({
  HOKKAIDO: '北海道',
  TOHOKU: '東北',
  KANTO: '関東',
  CHUBU: '中部',
  KINKI: '近畿',
  CHUGOKU: '中国',
  SHIKOKU: '四国',
  KYUSHU: '九州'
});

// 平坦な都道府県リスト（地域データから生成）
export const PREFECTURES = Object.freeze(Object.values(REGIONS).flat());

// 難易度レベル（構造化データ）
export const DIFFICULTY_LEVELS = Object.freeze({
  BEGINNER: { id: 'beginner', label: '初心者向け', color: 'green' },
  INTERMEDIATE: { id: 'intermediate', label: '中級者向け', color: 'orange' },
  ADVANCED: { id: 'advanced', label: '上級者向け', color: 'red' }
});

// 募集ステータス（構造化データ）
export const RECRUITMENT_STATUS = Object.freeze({
  ACTIVE: { id: 'active', label: '募集中', color: 'blue' },
  CLOSED: { id: 'closed', label: '募集終了', color: 'gray' }
});

// バリデーションルール（不変性担保）
export const VALIDATION_RULES = Object.freeze({
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PASSWORD_MIN_LENGTH: 6,
  NICKNAME_MAX_LENGTH: 50,
  MOUNTAIN_NAME_MAX_LENGTH: 100,
  ROUTE_MAX_LENGTH: 200,
  DESCRIPTION_MAX_LENGTH: 2000,
  EQUIPMENT_MAX_LENGTH: 1000,
  MEETING_POINT_MAX_LENGTH: 200,
  MAX_PARTICIPANTS: 20,
  MIN_PARTICIPANTS: 1
});

// エラーメッセージ（定数を参照）
export const ERROR_MESSAGES = Object.freeze({
  LOGIN_FAILED: 'ログインに失敗しました。',
  PASSWORD_TOO_SHORT: `パスワードは${VALIDATION_RULES.PASSWORD_MIN_LENGTH}文字以上で入力してください。`,
  MOUNTAIN_NAME_TOO_LONG: `山名は${VALIDATION_RULES.MOUNTAIN_NAME_MAX_LENGTH}文字以内で入力してください。`,
  DESCRIPTION_TOO_LONG: `詳細は${VALIDATION_RULES.DESCRIPTION_MAX_LENGTH}文字以内で入力してください。`,
  PARTICIPANTS_OUT_OF_RANGE: `参加人数は${VALIDATION_RULES.MIN_PARTICIPANTS}〜${VALIDATION_RULES.MAX_PARTICIPANTS}人の範囲で指定してください。`,
  NETWORK_ERROR: 'ネットワークエラーが発生しました。',
  UNAUTHORIZED: 'この操作にはログインが必要です。',
  NOT_FOUND: '要求されたリソースが見つかりません。',
  SERVER_ERROR: 'サーバーエラーが発生しました。',
  ALREADY_APPLIED: '既に応募しています。',
  RECRUITMENT_FULL: '募集人数に達しています。'
});
